import { makeStyles, Typography } from "@material-ui/core"
import { FC } from "react"
import { colors } from "../../utils/theme"
import HelpIcon from "../atoms/HelpIcon"
import { Tooltip } from "../atoms/tooltip/Tooltip"

const useStyles = makeStyles((theme) => ({
  tooltip: {
    width: 194,
    maxWidth: 194,
    minWidth: 194,
  },
  title: {
    color: colors.neutral.white,
    fontWeight: 700,
    marginBottom: 4,
  },
  item: {
    display: "flex",
    alignItems: "center",
  },
  itemIcon: {
    marginRight: theme.spacing(1),
    height: 16,
    width: 16,
    borderRadius: 4,
  },
  itemText: {
    color: colors.neutral.white,
    fontWeight: 400,
  },
  container: {
    height: 25,
    width: 50,
  },
}))

const TechniqueAndInterventionsHelpIcon: FC = () => {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      <Tooltip
        placement="top-end"
        title={
          <>
            <Typography variant="body1" className={classes.title}>
              More options
            </Typography>
          </>
        }
        className={classes.tooltip}
      >
        <HelpIcon />
      </Tooltip>
    </div>
  )
}

export default TechniqueAndInterventionsHelpIcon
